// src/layouts/RootLayout.tsx
import { Outlet } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";

export default function RootLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      {/* CSS global leve (não afeta SVG dos ícones) */}
      <style>{`
        /* Evita que mídias estourem o container e as mantém centralizadas horizontalmente */
        img, video, canvas {
          max-width: 100%;
          height: auto;
          display: block;
          margin-inline: auto; /* centra se a largura for menor que o container */
        }

        /* Ajuda a rolagem com header fixo quando há âncoras/ids na página */
        :where([id]) { scroll-margin-top: 5rem; }

        /* Utilitário opcional: envolva qualquer bloco com esta classe para centralizar o conteúdo interno */
        .media-center {
          display: flex;
          align-items: center;
          justify-content: center;
        }
      `}</style>

      {/* Header global em TODAS as páginas */}
      <Header />

      {/* Compensa o header fixo (h-16). Se seu Header crescer, aumente este padding. */}
      <main className="flex-1 pt-16">
        <Outlet />
      </main>

      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
